<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic :title="report.Title" v-if="report.Title" />
    </template>

    <div class="form-report">
      <gc-form-report
        v-if="report.Parameters"
        :gridToolbar="gridToolbar"
        :reportConfig="report"
        :setLoading="setLoading"
      >
      </gc-form-report>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FormattedReportLayoutService } from "../_services/api/reports/formatted-report.service";
import { FeatureStorage } from "../_services/storage";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {},

  data() {
    return {
      backButtonRoute: `/reports/${this.$route.params.category}`,
      report: {
        title: "",
        exportFileName: "",
        featureCode: "",
        dataSourceConfig: null,
        parameters: undefined,
      },

      // tempData: {
      //   ApplicationFeatureCode: "ReportSalesOrder",
      //   Location: "ReportsStandard/SalesOrder.repx",
      //   route: "sales-order",
      //   Title: "Sales Order",
      //   Parameters: [
      //     {
      //       screenField: "Customer",
      //       filterRequired: true,
      //       filterEditorType: "select",
      //     },
      //     {
      //       screenField: "DateIn",
      //       filterRequired: false,
      //     },
      //     {
      //       screenField: "ShipDate",
      //       filterRequired: true,
      //     },

      //     {
      //       screenField: "SalesOrder",
      //       filterRequired: true,
      //       filterEditorType: "select",
      //     },
      //   ],
      // },
    };
  },
  computed: {
    gridToolbar() {
      return {
        search: true,
        columnChooser: true,
        export: true,
        openFilter: true,
      };
    },
    columns() {
      var cols = this.report.columns;

      return cols;
    },
  },

  async created() {
    let response = await FormattedReportLayoutService.getByRoute(
      this.$route.params.reportroute
    );

    if (response.data) {
      this.report = response.data;
      this.report.Parameters = JSON.parse(response.data.Parameters);
      var featureItems = FeatureStorage.getItems().filter(
        (x) => x.ApplicationFeatureCode == this.report.ApplicationFeatureCode
      );
      if (featureItems) this.report.Title = featureItems[0].DisplayName;
    }

    // this.report = this.tempData;
  },
  methods: {
    setLoading(val) {
      this.showLoading(val);
    },
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },
  },
};
</script>

<style lang="scss">
.form-report {
  height: 100%;
  // div {
  //   height: inherit;
  // }
}
</style>
